import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

// 동적 임포트
const Stats = lazy(() => import('@/pages/stats'));
const VisitorStats = lazy(() => import('@/pages/stats/VisitorStats'));
const SalesStats = lazy(() => import('@/pages/stats/SalesStats'));
const ViewsStats = lazy(() => import('@/pages/stats/ViewsStats'));
const SalesDetail = lazy(() => import('@/pages/stats/SalesDetail'));

// 통계 라우트
export const statsRoutes: TypedRouteObject = {
	path: ROOTS.STATS,
	element: withSuspense(Stats),
	handle: {
		title: '전체 통계',
		subTitle: '락앤런 트레일러닝 통계 현황',
		permission: 'STATS' as const
	},
	children: [
		{
			index: true,
			element: <Navigate to="visitor" replace />
		},
		// 방문자 통계
		{
			path: paths.stats.visitor.path,
			element: withSuspense(VisitorStats),
			handle: {
				title: '전체 통계',
				subTitle: '락앤런 트레일러닝 통계 현황'
			}
		},
		// 매출 집계
		{
			path: paths.stats.sales.path,
			element: withSuspense(SalesStats),
			handle: {
				title: '전체 통계',
				subTitle: '락앤런 트레일러닝 통계 현황'
			}
		},
		// 조회수
		{
			path: paths.stats.views.path,
			element: withSuspense(ViewsStats),
			handle: {
				title: '전체 통계',
				subTitle: '락앤런 트레일러닝 통계 현황'
			}
		},
		// 매출 집계 상세
		{
			path: paths.stats.salesDetail.path,
			element: withSuspense(SalesDetail),
			handle: {
				isGoBack: true,
				title: '락앤런 고객향 매출액 현황',
				subTitle: '통계 > 매출 집계 > 상세정보'
			}
		}
	]
};
